import React from 'react';
import { BaseLayout } from './BaseLayout';
import { layoutConfigs } from './layoutConfigs';
import { AssessorSidebar } from './AssessorSidebar';

interface AssessorLayoutProps {
  children: React.ReactNode;
}

export const AssessorLayout: React.FC<AssessorLayoutProps> = ({ children }) => {
  return (
    <BaseLayout
      sidebar={<AssessorSidebar />}
      config={layoutConfigs.assessor}
    >
      {children}
    </BaseLayout>
  );
};
